/**
 * Created by razial on 18.09.2026.
 */

cleverapps.Tool.growthFund = {
    setRewardsLvl: function (lvl) {
        if (!cleverapps.growthFund) {
            return;
        }

        const callback = function (lvl) {
            if (isNaN(lvl)) {
                return;
            }
            lvl = Math.max(0, Math.min(lvl, cleverapps.user.currentPhysicalLevel.level));

            let received = cleverapps.growthFund.isBought() ? 0 : -1;
            cleverapps.growthFund.levels.forEach((level) => {
                if (level.levelNo <= lvl) {
                    received = level.levelNo;
                }
            });

            cleverapps.growthFund.received = received;
            cleverapps.growthFund.calcLevelsState();
            cleverapps.growthFund.trigger("updateState");
            cleverapps.growthFund.save();

            const win = cleverapps.focusManager.currentWindow();
            if (win && win instanceof GrowthFundWindow) {
                win.close();
            }
        };

        if (lvl === undefined) {
            displayToolPrompt(callback, "Level", 1);
        } else {
            callback(lvl);
        }
    },

    reset: function () {
        if (!cleverapps.growthFund) {
            return;
        }
        cleverapps.growthFund.received = -1;
        cleverapps.growthFund.calcLevelsState();
        cleverapps.growthFund.trigger("updateState");
        cleverapps.growthFund.save();
    }
};
